import { CancelFilled } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React from 'react';
import styles from "./Tag.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Tag = ({
  active,
  title,
  children,
  size = 'default',
  variant = 'primary',
  removable = false,
  disabled = false,
  margin = true,
  onClick,
  className,
  hasError = false
}) => {
  const classes = classnames(styles[size], styles[variant], {
    [styles.active]: active,
    [styles.margin]: margin,
    [styles.removable]: removable,
    [styles.disabled]: disabled,
    [styles.error]: hasError
  });
  return /*#__PURE__*/_jsx("button", {
    className: classnames(styles.tag, classes, className),
    onClick: disabled ? undefined : onClick,
    type: "button",
    title: title ?? (typeof children === 'string' ? children : undefined),
    "aria-pressed": active,
    children: /*#__PURE__*/_jsxs("span", {
      className: classnames(styles.content, classes),
      children: [/*#__PURE__*/_jsx("span", {
        children: children
      }), removable && /*#__PURE__*/_jsx(CancelFilled, {
        className: styles.icon,
        size: "SMALL"
      })]
    })
  });
};